module.exports = __webpack_public_path__ + "img/djxc.b2f65612.png";